import { h } from 'preact';
import { render } from 'preact';
import { InitiativesTable } from './InitiativesTable.jsx';
import { initInitiativesBridge } from '../../store/initiativesBridge.js';

export function mountInitiatives(host) {
  try { initInitiativesBridge(); } catch (_) {}
  const onEdit = (id) => {
    try {
      const mod = window.App?.getModule?.('initiatives');
      if (mod) { mod.editingId = id; mod.currentView = 'form'; mod.render(); }
    } catch(_) {}
  };
  const onDelete = async (id) => {
    try { await window.InitiativeService?.deleteInitiative?.(id); } catch(_) {}
  };
  render(<InitiativesTable onEdit={onEdit} onDelete={onDelete} />, host);
}

export default mountInitiatives;
